import axios from "axios";

export const state = {
    inpatients: [],
};

export const getters = {
    inpatients: state => state.inpatients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.inpatients = newValue
    },
};

export const actions = {
    fetchInPatients({ commit }, params = {}) {
        return axios.get('/inpatients', { params }).then(res => {
            commit('setPatients', res.data.treatments)
            return res;
        })
    },
};
